<script>
import { pageTitleMixin } from '@ubic/vue-mixins';

export default {
  pageTitle: 'Вход в панель управления',
  mixins: [pageTitleMixin],
  data () {
    return {
      username: '',
      password: '',
      isSubmitting: false,
      error: '',
    };
  },
  methods: {
    handleInput (e) {
      const { target } = e;

      if (target.name in this) {
        this[target.name] = target.value;
      }
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      const { username, password } = this;

      this.error = '';
      this.isSubmitting = true;

      try {
        await this.$store.dispatch('auth/login', { username, password });
      } catch (err) {
        const isWrongCredintails = err.response
          && err.response.status
          && (err.response.status === 401);

        if (isWrongCredintails) {
          this.error = 'Неверный логин или пароль';
        } else {
          this.erorr = 'неизвестная ошибка';
        }
      }

      this.isSubmitting = false;
    },
  },
  render () {
    const {
      $style,
      error,
      isSubmitting,
      username,
      password,
      handleSubmit,
      handleInput,
    } = this;

    return (
      <div class={$style.wrapper}>
        <u-title class={$style.title}>
          Вход в панель управления
        </u-title>
        <form
          action="#"
          method="post"
          class={$style.form}
          onInput={handleInput}
          onSubmit={handleSubmit}
        >
          <div class={$style.formGroup}>
            <label
              for="usernameInput"
              class={$style.formLabel}
            >
              Логин
            </label>
            <u-input
              id="usernameInput"
              name="username"
              value={username}
            />
          </div>
          <div class={$style.formGroup}>
            <label
              for="passwordInput"
              class={$style.formLabel}
            >
              Пароль
            </label>
            <u-input
              id="passwordInput"
              name="password"
              type="password"
              value={password}
            />
          </div>
          {error ? (
            <div class={$style.error}>
              {error}
            </div>
          ) : null}
          <div class={$style.formSubmit}>
            <u-btn
              size="wide"
              type="submit"
            >
              {!isSubmitting ? (
                'Войти'
              ) : (
                <u-spinner inline />
              )}
            </u-btn>
          </div>
        </form>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
.wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 7em 2em;
}

.title {
  border-bottom: 0;
}

.form {
  &Group {
    margin-bottom: 1em;
  }

  &Label {
    display: block;
    margin-bottom: .125em;
  }

  &Submit {
    margin-top: 2em;
    text-align: center;
  }
}

.error {
  color: hsl(9, 100%, 41%);
  font-size: .75em;
  text-align: center;
}
</style>
